export const FORM_NAME = 'loginPage'
